<div [hidden]="userAlert === null || !userAlert?.alertMessage">
    <div class="user-alert-bar" [ngClass]="alertClass">
        <div class="user-alert-icon"><i class='csx-common_alert'></i></div>
        <div class="user-alert-message"><span>{{userAlert?.alertMessage}}</span></div>
    </div>
</div>